/**
 * Base URL for signup app (OTP → /emailVerified, legacy redirects to /?entity=…).
 * Set REACT_APP_SIGNUP_SITE_ORIGIN in .env (e.g. http://signup.itradepro.godocm.com).
 */
export function getSignupSiteOrigin() {
  return (
    process.env.REACT_APP_SIGNUP_SITE_ORIGIN ||
    (typeof window !== "undefined" ? window.location.origin : "") ||
    "http://signup.itradepro.godocm.com"
  ).replace(/\/$/, "");
}

export function getSignupPublicPath() {
  return !process.env.PUBLIC_URL || process.env.PUBLIC_URL === "/"
    ? ""
    : String(process.env.PUBLIC_URL).replace(/\/$/, "");
}
